// extracted by mini-css-extract-plugin
export var fastFactsStacked = "fast-facts-stacked-module--fast-facts-stacked--75569";
export var fastFactsStacked__body = "fast-facts-stacked-module--fast-facts-stacked__body--667bb";
export var fastFactsStacked__facts = "fast-facts-stacked-module--fast-facts-stacked__facts--0f43f";
export var fastFactsStacked__image = "fast-facts-stacked-module--fast-facts-stacked__image--a35e4";
export var fastFactsStacked__title = "fast-facts-stacked-module--fast-facts-stacked__title--2c6d8";
export var mt0 = "fast-facts-stacked-module--mt-0--de25c";
export var mt1 = "fast-facts-stacked-module--mt-1--c207b";
export var mt2 = "fast-facts-stacked-module--mt-2--16a32";
export var mt3 = "fast-facts-stacked-module--mt-3--f0810";
export var mt4 = "fast-facts-stacked-module--mt-4--8196e";
export var mt5 = "fast-facts-stacked-module--mt-5--244a4";
export var mt6 = "fast-facts-stacked-module--mt-6--df68c";